import { LoadingModal } from "components/TP/Common/Modals"
import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { switchAccount } from "store/actions"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import MultiSkeleton from "components/TP/Common/MultiSkeleton"
import { getLoggedInUser } from "utils"
import { showUsers } from "helpers/Settings/Users/users_helper"

const SwitchAccountDropdown = () => {
  const dispatch = useDispatch()

  const { loading } = useSelector((state) => ({
    loading: state.Login.loading,
  }))

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const [linkedUsers, setLinkedUsers] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getLinkedUsers = async () => {
    const loggedInUser = getLoggedInUser()
    const loggedInUserId = loggedInUser?.id
    if (!loggedInUserId) return
    try {
      setIsLoading(true)
      const userRes = await showUsers(loggedInUserId)
      const linked = userRes?.item?.linked_users || []
      setLinkedUsers(linked)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      const errorMessage = apiErrorrHandler(error)
      NotificationMessage("Error", errorMessage)
    }
  }
  useEffect(() => {
    if (isMenuOpen) {
      getLinkedUsers()
    } else {
      return
    }
  }, [isMenuOpen])

  return (
    <Fragment>
      <Dropdown
        isOpen={isMenuOpen}
        toggle={() => setIsMenuOpen(!isMenuOpen)}
        className="align-self-center"
      >
        {/* Export DropDown Toggle */}
        <DropdownToggle
          className="btn btn-md bg-transparent font-size-18 header-item text-white"
          aria-label="switch account"
        >
          <i className="mdi mdi-account-switch font-size-18" />
        </DropdownToggle>

        {/* Export Dropdown Menu Items */}
        <DropdownMenu className="dropdown-menu-end">
          {isLoading && linkedUsers.length < 1 && <MultiSkeleton length={7} />}
          {linkedUsers.length > 0 &&
            linkedUsers.map((item) => (
              <DropdownItem
                key={item.id}
                onClick={() => {
                  if (!item.id) return
                  dispatch(switchAccount(item?.id))
                }}
              >
                {item.name}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>

      <LoadingModal isOpen={loading} />
    </Fragment>
  )
}

export default SwitchAccountDropdown
